interface MidPageCTAProps {
  headline?: string;
  subtext?: string;
  ctaLabel?: string;
  light?: boolean;
}

export default function MidPageCTA({
  headline = "Don't Wait Until Your AC Fails",
  subtext = "Texas summers don't slow down — and neither do we. Same-day service available across McKinney & Dallas.",
  ctaLabel = "Check Availability",
  light,
}: MidPageCTAProps) {
  const wrapperBg = light
    ? "bg-gradient-to-r from-[#0284C7] to-[#0369A1]"
    : "bg-gradient-to-r from-[#0c2340] to-[#0a1e37]";
  const borderClass = light ? "" : "border border-[#0EA5E9]/18";
  const headColor = "text-white";
  const subColor = light ? "text-white/90" : "text-white/85";
  const dividerClass = light ? "border-white/25" : "border-[#0EA5E9]/20";
  const phoneBtnClass = light
    ? "border-white/30 text-white hover:bg-white/15"
    : "border-white/18 text-white hover:bg-white/8";

  return (
    <section className={`${wrapperBg} ${borderClass} relative overflow-hidden`}>
      {/* Subtle top shimmer */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#38bdf8]/30 to-transparent" />
      {/* Subtle bottom shimmer */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">

          {/* Left — Copy */}
          <div className="flex items-start gap-5">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/10 flex-shrink-0 mt-0.5">
              <i className="ri-flashlight-line text-white text-2xl"></i>
            </div>
            <div>
              <h3 className={`font-['Inter'] ${headColor} font-bold text-xl mb-1.5`}>{headline}</h3>
              <p className={`font-['Inter'] ${subColor} text-sm leading-relaxed max-w-sm`}>{subtext}</p>
            </div>
          </div>

          {/* Right — CTAs */}
          <div className={`flex flex-col sm:flex-row items-center gap-3 flex-shrink-0 pl-0 md:pl-10 border-t md:border-t-0 md:border-l ${dividerClass} pt-6 md:pt-0 md:pl-10 w-full md:w-auto`}>
            <a
              href="#quote"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-[#0a1f3c] font-['Inter'] font-bold text-sm px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_4px_20px_rgba(0,0,0,0.2)]"
            >
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-calendar-check-line text-[#0EA5E9] text-xs"></i>
              </div>
              {ctaLabel}
            </a>
            <a
              href="tel:2148703185"
              className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 border font-['Inter'] font-semibold text-sm px-7 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer ${phoneBtnClass}`}
            >
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              214-870-3185
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
